<template>
  <ToggleSwitch
    v-model="value"
    :options="options"
    :label="label"
  />
</template>

<script
  setup
  lang="ts"
  generic="TValue extends string | number | boolean"
>
import { useField } from "vee-validate"

const props = defineProps<{
  name: string
  label?: string
  options: readonly [Option<TValue>, Option<TValue>]
}>()

const { value } = useField<TValue>(toRef(props, "name"))
</script>
